import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { RootState } from "../../../app/store";
import superAdminMembershipManagementService from "./membershipManagementService"

interface MembershipManagmentStateTypes {
    fetchMembershipLists: {
      membershipListData: any;
      isLoading: boolean;
      isError: boolean;
      isSuccess: boolean;
      message: string;
    };
    createMembershipPLan: {
        isLoading: boolean;
        isError: boolean;
        isSuccess: boolean;
        message: string;
    };
    updateMembershipPLan: {
        isLoading: boolean;
        isError: boolean;
        isSuccess: boolean;
        message: string;
    };
    deleteMembershipPLan: {
      isLoading: boolean;
      isError: boolean;
      isSuccess: boolean;
      message: string;
    };
    fetchFeaturesList: {
      featuresListData: any;
      isLoading: boolean;
      isError: boolean;
      isSuccess: boolean;
      message: string;
    };
    createPlanFeature: {
      isLoading: boolean;
      isError: boolean;
      isSuccess: boolean;
      message: string;
    };
    updatePlanFeature: {
      isLoading: boolean;
      isError: boolean;
      isSuccess: boolean;
      message: string;
    };
    deletePlanFeature: {
      isLoading: boolean;
      isError: boolean;
      isSuccess: boolean;
      message: string;
    };
    fetchPlanDetails: {
      planDetailsData: any;
      isLoading: boolean;
      isError: boolean;
      isSuccess: boolean;
      message: string;
    };
  };

  const initialState: MembershipManagmentStateTypes = {
    fetchMembershipLists: {
        membershipListData: [],
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    createMembershipPLan: {
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    updateMembershipPLan: {
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    deleteMembershipPLan: {
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    fetchFeaturesList: {
      featuresListData: [],
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    createPlanFeature: {
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    updatePlanFeature: {
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    deletePlanFeature: {
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
    fetchPlanDetails: {
      planDetailsData: {},
      isLoading: false,
      isError: false,
      isSuccess: false,
      message: "",
    },
  }

  export const fetchMembershipLists = createAsyncThunk(
    "membershipManagement/fetchMembershipLists",
    async ({ networkTypeId, name , isActive }: { networkTypeId:any;name:any; isActive:any }, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.fetchMemberShipLists(
          { networkTypeId, name , isActive },
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  

  export const createMembershipPLan = createAsyncThunk(
    "membershipManagement/createMembershipPLan",
    async (payload:any, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.createMembershipPLan(
          payload,
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  export const updateMembershipPLan = createAsyncThunk(
    "membershipManagement/updateMembershipPLan",
    async (payload:any, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.updateMembershipPLan(
          payload,
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );
  export const deleteMembershipPLan = createAsyncThunk(
    "membershipManagement/deleteMembershipPLan",
    async (payload:any, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.deleteMembershipPLan(
          payload,
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );


 export const fetchFeaturesListData = createAsyncThunk(
    "membershipManagement/featuresListData",
    async ({ networkTypeId }: { networkTypeId:any }, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.fetchFeaturesList(
          { networkTypeId },
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  export const createPlanFeature = createAsyncThunk(
    "membershipManagement/createPlanFeature",
    async (payload: any, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.createPlanFeature(
          payload,
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  export const updatePlanFeature = createAsyncThunk(
    "membershipManagement/updatePlanFeature",
    async (payload: any, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.updatePlanFeature(
          payload,
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  export const deletePlanFeature = createAsyncThunk(
    "membershipManagement/deletePlanFeature",
    async (payload: any, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;
  
        const response = await superAdminMembershipManagementService.deletePlanFeature(
          payload,
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  // NEW: fetch plan details thunk
  export const fetchPlanDetails = createAsyncThunk(
    "membershipManagement/fetchPlanDetails",
    async ({ planId, networkTypeId }: { planId: any; networkTypeId: any }, thunkAPI) => {
      try {
        const state = thunkAPI.getState() as RootState;
        const token = state.superAdminAuth?.superAdminUser?.access_token;

        const response = await superAdminMembershipManagementService.fetchPlanDetails(
          { planId, networkTypeId },
          token
        );
        if (response.isSuccess) {
          return response;
        } else {
          throw new Error(response.message);
        }
      } catch (error: any) {
        const message =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        return thunkAPI.rejectWithValue(message);
      }
    }
  );

  const membershipManagementSlice = createSlice({
    name: "membershipManagement",
    initialState,
    reducers: {
      resetFetchMembershipLists: (state) => {
        state.fetchMembershipLists = initialState.fetchMembershipLists;
      },
      resetCreateMembershipPLan: (state) => {
        state.createMembershipPLan = initialState.createMembershipPLan;
      },
      resetUpdateMembershipPLan: (state) => {
        state.updateMembershipPLan = initialState.updateMembershipPLan;
      },
      resetDeleteMembershipPLan: (state) => {
        state.deleteMembershipPLan = initialState.deleteMembershipPLan;
      },
      resetFetchFeaturesListData: (state) => {
        state.fetchFeaturesList = initialState.fetchFeaturesList;
      },
      resetCreatePlanFeature: (state) => {
        state.createPlanFeature = initialState.createPlanFeature;
      },
      resetUpdatePlanFeature: (state) => {
        state.updatePlanFeature = initialState.updatePlanFeature;
      },
      resetDeletePlanFeature: (state) => {
        state.deletePlanFeature = initialState.deletePlanFeature;
      },
      resetFetchPlanDetails: (state) => {
        state.fetchPlanDetails = initialState.fetchPlanDetails;
      },
    },
    extraReducers: (builder) => {
      builder
  
        .addCase(fetchMembershipLists.pending, (state, action: PayloadAction<any>) => {
          state.fetchMembershipLists.isLoading = true;
        })
        .addCase(fetchMembershipLists.fulfilled, (state, action: PayloadAction<any>) => {
          state.fetchMembershipLists.isLoading = false;
          state.fetchMembershipLists.isSuccess = true;
          state.fetchMembershipLists.message = action.payload.message;
          state.fetchMembershipLists.membershipListData = action.payload.result;
        })
        .addCase(fetchMembershipLists.rejected, (state, action: PayloadAction<any>) => {
          state.fetchMembershipLists.isLoading = false;
          state.fetchMembershipLists.isError = true;
          state.fetchMembershipLists.message = action.payload;
        })

        .addCase(createMembershipPLan.pending, (state, action: PayloadAction<any>) => {
          state.createMembershipPLan.isLoading = true;
        })
        .addCase(createMembershipPLan.fulfilled, (state, action: PayloadAction<any>) => {
          state.createMembershipPLan.isLoading = false;
          state.createMembershipPLan.isSuccess = true;
          state.createMembershipPLan.message = action.payload.message;
        })
        .addCase(createMembershipPLan.rejected, (state, action: PayloadAction<any>) => {
          state.createMembershipPLan.isLoading = false;
          state.createMembershipPLan.isError = true;
          state.createMembershipPLan.message = action.payload;
        })

        .addCase(updateMembershipPLan.pending, (state, action: PayloadAction<any>) => {
          state.updateMembershipPLan.isLoading = true;
        })
        .addCase(updateMembershipPLan.fulfilled, (state, action: PayloadAction<any>) => {
          state.updateMembershipPLan.isLoading = false;
          state.updateMembershipPLan.isSuccess = true;
          state.updateMembershipPLan.message = action.payload.message;
        })
        .addCase(updateMembershipPLan.rejected, (state, action: PayloadAction<any>) => {
          state.updateMembershipPLan.isLoading = false;
          state.updateMembershipPLan.isError = true;
          state.updateMembershipPLan.message = action.payload;
        })
        .addCase(deleteMembershipPLan.pending, (state, action: PayloadAction<any>) => {
          state.deleteMembershipPLan.isLoading = true;
        })
        .addCase(deleteMembershipPLan.fulfilled, (state, action: PayloadAction<any>) => {
          state.deleteMembershipPLan.isLoading = false;
          state.deleteMembershipPLan.isSuccess = true;
          state.deleteMembershipPLan.message = action.payload.message;
        })
        .addCase(deleteMembershipPLan.rejected, (state, action: PayloadAction<any>) => {
          state.deleteMembershipPLan.isLoading = false;
          state.deleteMembershipPLan.isError = true;
          state.deleteMembershipPLan.message = action.payload;
        })

        .addCase(fetchFeaturesListData.pending, (state, action: PayloadAction<any>) => {
            state.fetchFeaturesList.isLoading = true;
          })
          .addCase(fetchFeaturesListData.fulfilled, (state, action: PayloadAction<any>) => {
            state.fetchFeaturesList.isLoading = false;
            state.fetchFeaturesList.isSuccess = true;
            state.fetchFeaturesList.message = action.payload.message;
            state.fetchFeaturesList.featuresListData = action.payload.result;
          })
          .addCase(fetchFeaturesListData.rejected, (state, action: PayloadAction<any>) => {
            state.fetchFeaturesList.isLoading = false;
            state.fetchFeaturesList.isError = true;
            state.fetchFeaturesList.message = action.payload;
          })

          .addCase(createPlanFeature.pending, (state, action: PayloadAction<any>) => {
            state.createPlanFeature.isLoading = true;
          })
          .addCase(createPlanFeature.fulfilled, (state, action: PayloadAction<any>) => {
            state.createPlanFeature.isLoading = false;
            state.createPlanFeature.isSuccess = true;
            state.createPlanFeature.message = action.payload.message;
          })
          .addCase(createPlanFeature.rejected, (state, action: PayloadAction<any>) => {
            state.createPlanFeature.isLoading = false;
            state.createPlanFeature.isError = true;
            state.createPlanFeature.message = action.payload;
          })

          .addCase(updatePlanFeature.pending, (state, action: PayloadAction<any>) => {
            state.updatePlanFeature.isLoading = true;
          })
          .addCase(updatePlanFeature.fulfilled, (state, action: PayloadAction<any>) => {
            state.updatePlanFeature.isLoading = false;
            state.updatePlanFeature.isSuccess = true;
            state.updatePlanFeature.message = action.payload.message;
          })
          .addCase(updatePlanFeature.rejected, (state, action: PayloadAction<any>) => {
            state.updatePlanFeature.isLoading = false;
            state.updatePlanFeature.isError = true;
            state.updatePlanFeature.message = action.payload;
          })

          .addCase(deletePlanFeature.pending, (state, action: PayloadAction<any>) => {
            state.deletePlanFeature.isLoading = true;
          })
          .addCase(deletePlanFeature.fulfilled, (state, action: PayloadAction<any>) => {
            state.deletePlanFeature.isLoading = false;
            state.deletePlanFeature.isSuccess = true;
            state.deletePlanFeature.message = action.payload.message;
          })
          .addCase(deletePlanFeature.rejected, (state, action: PayloadAction<any>) => {
            state.deletePlanFeature.isLoading = false;
            state.deletePlanFeature.isError = true;
            state.deletePlanFeature.message = action.payload;
          })

          // fetch plan details handlers
          .addCase(fetchPlanDetails.pending, (state, action: PayloadAction<any>) => {
            state.fetchPlanDetails.isLoading = true;
          })
          .addCase(fetchPlanDetails.fulfilled, (state, action: PayloadAction<any>) => {
            state.fetchPlanDetails.isLoading = false;
            state.fetchPlanDetails.isSuccess = true;
            state.fetchPlanDetails.message = action.payload.message;
            state.fetchPlanDetails.planDetailsData = action.payload.result;
          })
          .addCase(fetchPlanDetails.rejected, (state, action: PayloadAction<any>) => {
            state.fetchPlanDetails.isLoading = false;
            state.fetchPlanDetails.isError = true;
            state.fetchPlanDetails.message = action.payload;
          })
        
    },
  });

  export const {
    resetFetchMembershipLists,
    resetCreateMembershipPLan,
    resetUpdateMembershipPLan,
    resetDeleteMembershipPLan,
    resetFetchFeaturesListData,
    resetCreatePlanFeature,
    resetUpdatePlanFeature,
    resetDeletePlanFeature,
    resetFetchPlanDetails
  } = membershipManagementSlice.actions;
  
  export default membershipManagementSlice.reducer;